<div>
  <h5 class="c-black">Send Excel To Mail</h5>
  <div>
    <form action="" [formGroup]="emailForm">
      <div class="form-row">
        <mat-form-field class="material-full-width" appearance="outline">
          <mat-label>Email ID <span class="text-danger">*</span></mat-label>
          <input
            matInput
            formControlName="email"
            placeholder="Enter Email ID"
            oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-,]/g,'')"
            type="text"
            (keydown.space)="$event.preventDefault()"
            [ngClass]="{ 'is-invalid': add.email.touched && add.email.errors }"
          />

          <mat-error *ngIf="add.email.touched && add.email.errors">
            <span *ngIf="add.email.errors.required">Email ID is required</span>
            <span *ngIf="add.email.errors.invalidEmails">
              <i class="fas fa-exclamation-triangle"></i>
              Pleace Enter Valid Email
            </span>
          </mat-error>
        </mat-form-field>
        <span class="multiple">
          For multiple emails use a comma between addresses. E.g.,
          test@Incubation.com,support@Incubation.com
        </span>
      </div>
    </form>
    <div class="text-center mt-3">
      <button class="cancel-excel" (click)="cancel()">Cancel</button>
      <button class="save-excel" (click)="ExcelSave()">Send Mail</button>
    </div>
  </div>
</div>
